import axios from "axios";
import { api_url } from "../config/config";

const regleCalculService = {
  getReglesCalcul: async () => {
    const response = await axios.get(`${api_url}vehicules-flotte/regles-de-calcul`);
    return response.data;
  },
};

export default regleCalculService;
